var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Badge',{staticClass:"status-base",attrs:{"status":_vm.calloutStatus}},[(_vm.status === 'failed')?_c('StakeTooltip',{attrs:{"label":_vm.failureReason}},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")]):_c('span',[_vm._v(_vm._s(_vm.message))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }